import React, { FC } from 'react';
import QrLink from '/react4xp/parts/block-qr-links/components/qr-link';
import '/site/parts/block-qr-links/block-qr-links.scss';

type QrLinkItem = {
    title?: string;
    code?: string;
    link?: string;
};

type BlockQrLinksProps = {
    links?: QrLinkItem[];
    translations?: Record<string, string>;
};

const BlockQrLinks: FC<BlockQrLinksProps> = (props) => {
    return (
        <div className="block-qr-links hide-on-mobile hide-on-tablet">
            {props.links && props.links.map((x) => <QrLink link={x} />)}
        </div>
    );
};

export default BlockQrLinks;
